 <div class="popup-box-arrow" [ngStyle]="getPopupBoxArrowStyle()">
    <span class="popup-box-arrowOut" [ngStyle]="getPopupBoxArrowOutStyle()">
      <i class="popup-box-arrowIn" [ngStyle]="getPopupBoxArrowInStyle()"></i>
  </span>
</div>